var tabs = document.querySelectorAll("[data-tab-id]");

for (let i = 0; i < tabs.length; i++) {
  tabs[i].onclick = function () {
    var tabId = tabs[i].dataset.tabId;
    var tabContents = tabs[i]
      .closest(".box.container")
      .querySelectorAll("[data-tab-content-id]");
    for (let j = 0; j < tabContents.length; j++) {
      if (tabContents[j].dataset.tabContentId === tabId) {
        tabContents[j].classList.add("active");
      } else {
        tabContents[j].classList.remove("active");
      }
    }
    tabs[i].classList.add("active");
    var tabOthers = tabs[i]
      .closest(".box.container")
      .querySelectorAll('.box-tab-title:not([data-tab-id="' + tabId + '"])');
    tabOthers.forEach((tabOther) => {
      tabOther.classList.remove("active");
    });
  };
}
